import { Skeleton, Stack } from "@mui/material"

function ContentListSkeleton() {
    return (
        <div className="flex flex-col gap-3">
            <Stack spacing={1} className="w-full" >
                <Skeleton variant="rounded" height={100} className="w-full" />
            </Stack>
            <Stack spacing={1} className="w-full" >
                <Skeleton variant="rounded" height={100} className="w-full" />
            </Stack>
            <Stack spacing={1} className="w-full" >
                <Skeleton variant="rounded" height={100} className="w-full" />
            </Stack>
            <Stack spacing={1} className="w-full" >
                <Skeleton variant="rounded" height={100} className="w-full" />
            </Stack>
        </div>
    )
}

export default ContentListSkeleton